module.exports = __webpack_public_path__ + "static/media/MasterChief.067c7493.jpg";